import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=3477b0ba&scoped=true&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"
import style0 from "./InputField.vue?vue&type=style&index=0&id=3477b0ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3477b0ba",
  null
  
)

export default component.exports